<template>
  <input
    ref="input"
    v-bind:value="value"
    @input="updateValue($event.target.value)"
    @focus="selectAll"
    @blur="formatValue"
  />
</template>

<script>
import numeral from 'numeral'
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  mounted: function () {
    this.formatValue()
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', numeral(value).format('0.00'))
    },
    formatValue: function () {
      this.$refs.input.value = numeral(this.value).format('0.00')
    },
    selectAll: function (event) {
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select()
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/InputDecimal.vue